<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <h1>{{ $t('menu.messageSent') }}</h1>
            <piaf-breadcrumb />
            <b-row>
                <b-colxx xxs="12">
                    <b-card class="mb-4" title="발송 리스트">
                        <!-- {{ content }} -->
                        <b-table head-variant="light" ref="general-table" :currentpage="currentPage" class="vuetable" selectedVariant="primary" :items="items" :fields="fields" :per-page="perPage" primary-key="settingId" responsive show-empty>
                            <template v-slot:cell(sendDateTime)="row">
                                {{ $moment(row.item.sendDateTime).format('YYYY-MM-DD HH:mm')}}
                            </template>
                            <template v-slot:cell(message)="row">
                                <span class="textMax">{{row.item.message}}</span>
                            </template>
                            <template v-slot:cell(sendCount)="row">
                                {{row.item.sendCount}}
                            </template>
                            <template v-slot:cell(status)="row">
                                {{ row.item.status === true ? '발송완료':'발송실패' }}
                            </template>
                            <template v-slot:cell(detail)="row">
                                <b-btn @click="messageDetail(row.item.id)">보기</b-btn>
                            </template>
                            <template v-slot:empty>
                                <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
                            </template>
                        </b-table>
                        <b-pagination v-if="lastPage > 1" size="sm" align="center" :total-rows="total" :per-page="perPage" v-model="currentPage">
                            <template v-slot:next-text>
                                <i class="simple-icon-arrow-right" />
                            </template>
                            <template v-slot:prev-text>
                                <i class="simple-icon-arrow-left" />
                            </template>
                            <template v-slot:first-text>
                                <i class="simple-icon-control-start" />
                            </template>
                            <template v-slot:last-text>
                                <i class="simple-icon-control-end" />
                            </template>
                        </b-pagination>
                    </b-card>
                </b-colxx>
            </b-row>
        </b-colxx>
    </b-row>
    <messageDetail ref="mcom" />
</div>
</template>

<script>
import {
    alignTableCenter
} from '../../utils';
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
import {
    rescode,
} from "../../constants/common";
import {
    reqGet,
    reqPost
} from "../../constants/request";
import api from '../../constants/api';

import messageDetail from './component/messageDetail';

export default {
    components: {
        messageDetail
    },
    data() {
        return {
            mId: 0,
            perPage: 20,
            searchKeyword: '',
            total: 1,
            lastPage: 1,
            currentPage: 1,
            totalPages: 0, //전체 페이지 수
            totalElements: 0, //전체 아이템 수
            numberOfElements: 0, //현재 조회된 아이템 수
            first: true, //첫 페이지일 경우 true
            last: false, //마지막 페이지일 경우 true
            items: [],
            fields: [{
                    key: 'sendDateTime',
                    label: '발송일',
                    ...alignTableCenter
                },
                {
                    key: 'title',
                    label: '제목',
                    ...alignTableCenter
                },
                {
                    key: 'message',
                    label: '내용',
                    ...alignTableCenter
                },
                {
                    key: 'sendCount',
                    label: '총 발송',
                    ...alignTableCenter
                },
                {
                    key: 'status',
                    label: '상태',
                    ...alignTableCenter
                },
                {
                    key: 'detail',
                    label: '상세내역',
                    ...alignTableCenter
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName', 'brandInfo'])
    },
    mounted() {
        this.getListPage();
    },
    watch: {
        currentPage() {
            this.getListPage()
        }
    },
    methods: {
        messageDetail(id) {
            this.mId = id;
            this.$refs.mcom.getListDetailPage(id);
            this.$refs.mcom.showModal();
        },
        getListPage() {
            this.items = [];
            reqPost(
                api.changeAPI(this.siteName, api.basicURL + api.message.sms_history_list_page),
                this.currentUser.tokens.access.token, {
                    keywordType: 'BrandCode',
                    keyword: this.brandInfo.brandCode,
                    pageNumber: (this.currentPage - 1),
                    pageSize: this.perPage,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {

                            this.items = result.data.content;
                            this.total = result.data.totalElements; //전체 아이템 수
                            this.numberOfElements = result.data.numberOfElements; //현재 조회된 아이템 수
                            this.lastPage = result.data.totalPages;

                        } else {
                            this.items = [];
                            this.total = 0; //전체 페이지 수
                            this.totalElements = 0; //전체 아이템 수
                            this.lastPage = 0; //현재 조회된 아이템 수
                        }
                    }
                }
            );
        },
    }
}
</script>

<style>
.font-size-big>legend {
    font-size: 1rem;
    font-weight: 600;
}

.textMax {
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 148px;
    display: block;
    text-align: center;
    margin: auto;
}
</style>
